export const ITEM_UPLOAD_URL = '/items/new'
export const REFERRALS_URL = '/referrals'
